import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import StyleButton from './StyleButton'

function BlockStyleControls({ editorState, onToggle }) {
  const styles = [
    { label: 'quote-left', style: 'blockquote' },
    { label: 'list-ul', style: 'unordered-list-item' },
    { label: 'list-ol', style: 'ordered-list-item' },
  ]

  const selection = editorState.getSelection()

  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType()

  return (
    <Fragment>
      {styles.map((type) => (
        <StyleButton
          key={type.label}
          isActive={type.style === blockType}
          label={type.label}
          onToggle={onToggle}
          style={type.style}
        />
      ))}
    </Fragment>
  )
}

BlockStyleControls.propTypes = {
  editorState: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
}

export default BlockStyleControls
